import * as React from 'react'
import { tourTypeToIcon } from '../../../../common/src/components/Icon'
import { Spacer } from '../../../../common/src/components/core'
import { TourType } from '../../../../common/src/types.gen'

/**
 * Takes tourType as enum, gives back pretty JSX element of icon + tour type. Takes an optional `align` parameter.
 */
export function TourTypeWithIcon({ tourType, align }: { tourType: TourType; align?: string }) {
  switch (align) {
    case 'right':
      // `right` returns `tourType [icon]`
      return (
        <>
          {formatTourTypeName(tourType)}
          <Spacer width={8}></Spacer>
          {tourTypeToIcon(tourType)}
        </>
      )
    default:
    case 'left':
      // undefined or `left` returns `[icon] tourType`
      return (
        <>
          {tourTypeToIcon(tourType)}
          <Spacer width={8}></Spacer>
          {formatTourTypeName(tourType)}
        </>
      )
  }
}

/**
 * Takes tourType as enum, prints grammatically correct display string
 */
export function formatTourTypeName(tourType: TourType) {
  switch (tourType) {
    case TourType.SELF_GUIDED:
      return 'Self-Guided'
    case TourType.VIRTUAL:
      return 'Virtual'
    case TourType.IN_PERSON:
      return 'In-Person'
    default:
      return null
  }
}
